import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ProjectType } from '../state-man/models/project-type.model';
import { UiService } from './ui.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectTypeService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  public async getAll () : Promise<ProjectType[] | null> {      
    try {
      const ret = await this.apiService.apiReturnsAny('get', 'project_type/active/')           
      return (ret && Array.isArray(ret)) ? ProjectType.buildMany(ret) : null
    } 
    catch (error) {    
      LoggerService.log(error + 'project_type/active/')   
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')      
      return null
    }
  }  
  
}
